import { createSlice } from "@reduxjs/toolkit";

const verifyTypeSlice = createSlice({
  name: "verifyType",
  initialState: {
    type: "withHN",
    privilege: {},
  },
  reducers: {
    setVerifyType: (state, action) => {
      state.type = action.payload;
    },
    setPrivilege: (state, action) => {
      state.privilege = action.payload;
    },
  },
});

export const { setVerifyType, setPrivilege } = verifyTypeSlice.actions;

export default verifyTypeSlice.reducer;
